@if (form) {
  <form [formGroup]="form">
    @if (loaded) {
      <se-fe-form-field
    [seFeDataConfig]="{
      label: seFeDataLabel,
      errorMessages: {
        required: 'SE_PO_UI_GRADUATION_SELECT.ERRORS.required' | translate
      }
    }">
      <se-fe-form-field-suffix
        [seFeDataSuffix]="grade"
        seFeDataSize="5">
        <se-fe-form-field-select
          [formControlName]="ngControl.name"
          [seFeDataOptions]="graduationYearOptions"
          [seFeDataComfy]="true">
        </se-fe-form-field-select>
      </se-fe-form-field-suffix>
      @if (control['helpText']) {
        <div seFeHelp>
          {{ control['helpText'] }}
        </div>
      }
      <ng-content select="[seFeHelp]"></ng-content>
    </se-fe-form-field>
  }
</form>
}
